<template>
    <a-row type="flex" align="stretch" class="dash-section" :gutter="[16,16]">
        <a-col :span="6">
            <a-card class="profile-card" :bordered="false">
                <a-row :gutter="[16,16]" type="flex" align="middle">
                    <a-col :span="10" class="text-center">
                        <a-avatar :src="user().photo" :size="120" :alt="userInfo.name">{{ getInitial(userInfo.name) }}</a-avatar>
                    </a-col>
                    <a-col :span="14">
                        <img class="client-logo" :src="bank.logo"  />
                        <br>
                        <br>
                        <h2>{{ userInfo.name }}</h2>
                        <p><a-icon type="mail" /> <strong>{{ userInfo.email }}</strong></p>
                        <p><a-icon type="phone" /> <strong>{{ userInfo.mobile_phone }}</strong></p>
                    </a-col>
                </a-row>
            </a-card>
        </a-col>
        <a-col :span="18">
            <a-card type="inner" size="small" class="profile-card" :bordered="false">
                <div class="text-right" v-if="current_user.hash === userInfo.hash || userInfo.is_admin">
                    <a-button :disabled="processing" :type="editing ? 'default' : 'primary'" @click="toggleEdit">{{ editing ? 'Cancel' : 'Edit' }}</a-button>
                </div>
                <a-descriptions bordered style="margin: 24px 0;">
                    <a-descriptions-item label="Nama" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.name" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.name }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Status Pernikahan" :span="2">
                        <template v-if="editing">
                            <a-select v-model="formData.family_status" style="width: 200px">
                                <a-select-option v-for="(v,k) in MARITAL_STATUS" :value="k" :key="`${'marital-' + k}`">{{ v }}</a-select-option>
                            </a-select>
                        </template>
                        <template v-else>
                            {{ MARITAL_STATUS[userInfo.family_status] }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Jenis Kelamin">
                        <template v-if="editing">
                            <a-radio-group v-model="formData.gender" button-style="solid">
                                <a-radio-button value="male"><a-icon type="man" /> L</a-radio-button>
                                <a-radio-button value="female"><a-icon type="woman" /> P</a-radio-button>
                            </a-radio-group>
                        </template>
                        <template v-else>
                            {{ GENDER[userInfo.gender] }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Tempat Lahir" :span="2">
                        <template v-if="editing">
                            <a-input v-model="formData.birthplace" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.birthplace || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Tgl. Lahir">
                        <template v-if="editing">
                            <a-date-picker defaultValue="moment(formData.birthday)" @change="(v) => formData.birthday = v.format('YYYY-MM-DD')" />
                        </template>
                        <template v-else>
                            {{ moment(userInfo.birthday).format('YYYY-MM-DD') || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Email" :span="2">
                        {{ userInfo.email }}
                    </a-descriptions-item>
                    <a-descriptions-item label="No. Telp (WA)">
                        <template v-if="editing">
                            <a-input v-model="formData.mobile_phone" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.mobile_phone }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Alamat Rumah" :span="2">
                        <template v-if="editing">
                            <a-input v-model="formData.home_address" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.home_address || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Telp. Rumah">
                        <template v-if="editing">
                            <a-input v-model="formData.home_phone" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.home_phone || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Jabatan" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.position" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.position || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Alamat Kantor" :span="2">
                        <template v-if="editing">
                            <a-input v-model="formData.office_address" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.office_address || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Telp. Kantor">
                        <template v-if="editing">
                            <a-input v-model="formData.office_phone" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.office_phone || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Pendidikan" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.education" style="width: 80%"  :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.education || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Jurusan" :span="2">
                        <template v-if="editing">
                            <a-input v-model="formData.majors" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.majors || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Universitas">
                        <template v-if="editing">
                            <a-input v-model="formData.university" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.university || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Hobby" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.hobby" style="width: 80%" :maxLength="255" />
                        </template>
                        <template v-else>
                            {{ userInfo.hobby || '-' }}
                        </template>
                    </a-descriptions-item>

                    <a-descriptions-item label="Facebook" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.facebook" style="width: 80%" :maxLength="255">
                                <a-icon slot="prefix" type="facebook" />
                            </a-input>
                        </template>
                        <template v-else>
                            <a-icon type="facebook" /> {{ userInfo.facebook || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="LinkedIn" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.linkedin" style="width: 80%" :maxLength="255">
                                <a-icon slot="prefix" type="linkedin" />
                            </a-input>
                        </template>
                        <template v-else>
                            <a-icon type="linkedin" /> {{ userInfo.linkedin || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Instagram" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.instagram" style="width: 80%" :maxLength="255">
                                <a-icon slot="prefix" type="instagram" />
                            </a-input>
                        </template>
                        <template v-else>
                            <a-icon type="instagram" /> {{ userInfo.instagram || '-' }}
                        </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Twitter" :span="3">
                        <template v-if="editing">
                            <a-input v-model="formData.twitter" style="width: 80%" :maxLength="255">
                                <a-icon slot="prefix" type="twitter" />
                            </a-input>
                        </template>
                        <template v-else>
                            <a-icon type="twitter" /> {{ userInfo.twitter || '-' }}
                        </template>
                    </a-descriptions-item>
                </a-descriptions>
                <div class="text-right">
                    <a-button type="primary" :loading="processing" v-if="editing" @click="submit">Save</a-button>
                </div>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
const MARITAL_STATUS = {
    undefined: '-',
    single: 'Lajang',
    married: 'Menikah',
    divorced: 'Janda/Duda'
}

const GENDER = {
    male: 'Laki-laki',
    female: 'Perempuan'
}
export default {
    props: {
        userInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            editing: false,
            formData: null,
            processing: false,
            MARITAL_STATUS,
            GENDER
        }
    },
    created() {
        this.formData = this.userInfo
    },
    computed: {
        bank() {
            return this.$laravel.bank
        },
        current_user() {
            return this.$laravel.user
        }
    },
    methods: {
        getInitial(name) {
             let names = name.split(' '),
                initials = names[0].substring(0, 1).toUpperCase();
            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase();
            }
            return initials
        },
        toggleEdit() {
            this.editing = ! this.editing
        },
        submit() {
            this.processing = true

            this.$http
                .post(this.routeUri('api.setting.profile.update', {user_hash: this.userInfo.hash}), this.formData)
                .then((r) => this.handleSuccessResponse(r.data))
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.processing = false)
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!";
            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }
            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => location.reload(), 1000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
    }
}
</script>
